import React from "react";
import { SectionHeading } from "../../atoms/SectionHeading";
import { EVENT_DETAILS_CONSTANTS } from "../../../constants";

import "./event-details-section.m.css";
import RsvpIcon from "../../../../assets/icons/rsvp";

export const EventDetailsSection = ({ eventTitle, eventSubtitle, eventDate, eventLocation, venue, venueAddress, contact, corporateAddress, imageUrl, contactAddress, contactPhone, venueImage, mapUrl, onBookSeatClick, onKeepMeInformedClick, hasUserPurchasedStory = false, storyTemplate, onRsvpClick }) => {
  return (
    <div styleName={`event-details-section`} data-section="venue-contact">
      <div styleName="event-details">
        <div styleName="event-title-metadata">
          <div styleName="title-subtitle">
            {eventTitle && <div styleName="title-wrapper">
              <SectionHeading>{eventTitle}</SectionHeading>
            </div>}
            {eventSubtitle && storyTemplate !== "session" && (
              <div styleName="subtitle">
                {eventSubtitle}
              </div>
            )}
          </div>
          <div styleName="event-info-buttons">
            <div styleName="event-info">
              {eventDate && <div styleName="event-info-item">
                {eventDate}
              </div>}
              {eventLocation && <div styleName="event-info-item">
                {eventLocation}
              </div>}
            </div>
            <div styleName="button-unit">
              <div
                styleName="button outline"
                onClick={onKeepMeInformedClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onKeepMeInformedClick && onKeepMeInformedClick();
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                {EVENT_DETAILS_CONSTANTS.KEEP_ME_INFORMED}
              </div>
              {storyTemplate !== "session" && <div
                styleName={`button primary ${hasUserPurchasedStory ? 'disabled' : ''}`}
                onClick={hasUserPurchasedStory ? undefined : onBookSeatClick}
                role={hasUserPurchasedStory ? undefined : "button"}
                tabIndex={hasUserPurchasedStory ? undefined : 0}
                onKeyDown={hasUserPurchasedStory ? undefined : (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onBookSeatClick && onBookSeatClick();
                  }
                }}
                style={hasUserPurchasedStory ? { cursor: 'not-allowed', opacity: 0.5 } : { cursor: 'pointer' }}
              >
                {EVENT_DETAILS_CONSTANTS.BOOK_A_SEAT}
              </div>}
              {storyTemplate === "session" && <div
                styleName={`button primary rsvp-button`}
                onClick={onRsvpClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onRsvpClick && onRsvpClick();
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <div styleName="rsvp-icon"><RsvpIcon /></div>
                RSVP
              </div>}
            </div>
          </div>
        </div>
        <div styleName="venue-details">
          <div styleName="venue-info">
            {venue && <div styleName="venue-label-title">
              <div styleName="venue-label">
                {EVENT_DETAILS_CONSTANTS.VENUE}
              </div>
              <div styleName="venue-title">
                {venue}
              </div>
            </div>}
            {venueAddress && <div styleName="venue-address">
              {venueAddress}
            </div>}
          </div>
          <div styleName="image-map">
            {venueImage || <img alt={venue || "Venue"} src={imageUrl} />}
            {mapUrl && <div
              styleName="action-button"
              onClick={() => mapUrl && window.open(mapUrl, '_blank')}
              role="button"
              tabIndex={0}
            >
               {EVENT_DETAILS_CONSTANTS.VIEW_ON_MAP}
            </div>}
          </div>
        </div>
      </div>
      <div styleName="contact-info">
        {(contact || contactAddress || contactPhone) && <div styleName="contact-item">
          <div styleName="contact-label">
            {EVENT_DETAILS_CONSTANTS.CONTACT}
          </div>
          <div styleName="contact-details">
            <div>{contact}</div>
            <div>{contactAddress}</div>
            <div>{contactPhone}</div>
          </div>
        </div>}
        {corporateAddress && <div styleName="contact-item">
          <div styleName="contact-label">
            {EVENT_DETAILS_CONSTANTS.CORPORATE_ADDRESS}
          </div>
          <div styleName="contact-details">
            <div>{corporateAddress}</div>
          </div>
        </div>}
      </div>
    </div>
  );
};